import React, {useState} from "react";
import "../css/GCPillButton.css";
import "../css/location.css";
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function LocationForm({fetchLocations, onClose}) {

  const [locationName, setLocationName] = useState("");
  const [locationLatitude, setLocationLatitude] = useState(0.0);
  const [locationLongitude, setLocationLongitude] = useState(0.0);
  const [locationPostcode, setLocationPostcode] = useState("");
  const [locationDescription, setLocationDescription] = useState("");
  const [locationWebsite, setLocationWebsite] = useState("");
  const [imageFile, setImageFile] = useState(null);

  const {language} = useLanguage();

  const translations = {
    en: {
      invalidPostcodeForm: "Form could not be submitted as you have entered an invalid postcode",
      invalidPostcode: "You have entered an invalid postcode",
      locationDescriptionLong: "Location Description - Enter a little bit about the location",
      websiteLink: "Please link to the location website",
      createLocation: "Create Location",
      locationAddedSuccessfully: "Location Added Successfully",
      addLocation: "Add Location",
      locationName: "Location Name: ",
      locationDescription: "Location Description: ",
      locationPostcode: "Location Postcode: ",
      latitude: "Latitude: ",
      longitude: "Longitude: ",
      locationWebsite: "Location Website: ",
      uploadImage: "Upload Image",
      cancel: "Cancel",
           
    },

    gd: {
      invalidPostcodeForm: "Cha ghabhadh an fhoirm a chur a-steach oir tha an  còd-puist mì-dhligheach",
      invalidPostcode: "Chuir thu a-steach còd-puist mì-dhligheach",
      locationDescriptionLong: "Tuairisgeul Àite - Cuir a-steach beagan mun àite",
      websiteLink: "Dèan ceangal ri làrach-lìn an àite",
      createLocation: "Cruthaich àite",
      locationAddedSuccessfully: "Àite air a chur ris gu soirbheachail",
      addLocation: "Cuir àite",
      locationName: "Ainm an Àite: ",
      locationDescription: "Tuairisgeul Àite: ",
      locationPostcode: "Còd-puist Àite: ",
      latitude: "Domhan-leud: ",
      longitude: "Domhan-fhad: ",
      locationWebsite: "Làrach-lìn Àite",
      uploadImage: "Luchdaich Suas Ìomhaigh",
      cancel: "Dubh às",
        
    },
};

  function checkNumeric(code) {
    return !isNaN(parseInt(code, 10))
  }

  const handleLocationSubmit = async (e) => {

    e.preventDefault();
    // fetchLocations();
    let errorDiv = document.getElementById("location-form-error");
    errorDiv.innerHTML = ''

    const valid_areas = ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE']
    const area_code = locationPostcode.substring(0,2);

    if (locationPostcode.length < 5 || locationPostcode.length > 8){
      errorDiv.innerHTML = `${translations[language].invalidPostcodeform}`;
      alert(`${translations[language].invalidPostcode}`);
    }else if (! valid_areas.includes(area_code.toUpperCase()) ){
      //consider edge case where area code is G[0-9]
      if (! (area_code.substring(0,1).toUpperCase() === 'G' && checkNumeric(area_code.substring(1,2)))){
        errorDiv.innerHTML = `${translations[language].invalidPostcodeForm}`;
        alert(`${translations[language].invalidPostcode}`);
      }
    }else{

      const response = await fetch(`${BASE_URL}/api/save_location_data/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "location_name": locationName,
          "location_latitude": locationLatitude,
          "location_longitude": locationLongitude,
          "location_postcode": locationPostcode,
          "location_description": locationDescription,
          "location_website": locationWebsite,
        })
      });

      const data = await response.json(); 

      if (data["status"] === "error") {
          console.log(data["message"]);
          errorDiv.innerHTML = data["message"];
          alert(data["message"]);

      }else{

          if (imageFile){
            const formData = new FormData();
            formData.append("location_name", locationName);
            formData.append("location_picture", imageFile);
            
            await fetch(`${BASE_URL}/api/upload_location_picture/`, {
              method: "POST",
              body: formData,
            });
          }

          alert(`${translations[language].locationAddedSuccessfully}`);
          onClose();
      }
    }
  
  }


  return(
    <div>

        <div className="event-form-header mb-4">
          <h1> {translations[language].addLocation} </h1>
          <button className= "close-x" onClick={onClose}>&times;</button> 
        </div>

        <div className="text-danger text-center mb-2" id="location-form-error"></div>

        <form onSubmit = {handleLocationSubmit}>
          <div className="form-group mb-3">
            <label>{translations[language].locationName}</label>
            <input
              required
              className="form-input form-control text-center"
              type="text"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              placeholder={translations[language].locationName}
            />
          </div>

          <div className="form-group mb-3">
            <label>{translations[language].locationDescription}</label>
            <textarea
              required
              className="form-input form-control text-center"
              type="text"
              rows="3"
              value={locationDescription}
              onChange={(e) => setLocationDescription(e.target.value)}
              placeholder={translations[language].locationNameLong}
            />
          </div>

          <div className="form-group mb-3">
            <label>{translations[language].locationPostcode}</label>
            <input
              required
              className="form-input form-control text-center"
              type="text"
              value={locationPostcode}
              onChange={(e) => setLocationPostcode(e.target.value)}
              placeholder={translations[language].locationPostcode}
            />
          </div>

          <div className="form-group mb-3">
            <label>{translations[language].latitude}: </label>
            <input
              required
              className="form-input form-control text-center"
              type="number"
              value={locationLatitude}
              onChange={(e) => setLocationLatitude(parseFloat(e.target.value))}
            />
          </div>

          <div className="form-group mb-3">
            <label>{translations[language].longitude} </label>
            <input
              required
              className="form-input form-control text-center"
              type="number"
              value={locationLongitude}
              onChange={(e) => setLocationLongitude(parseFloat(e.target.value))}
            />
          </div>

          <div className="form-group mb-3">
            <label>{translations[language].locationWebsite}</label>
            <input
              className="form-input form-control text-center"
              type="text"
              value={locationWebsite}
              onChange={(e) => setLocationWebsite(e.target.value)}
              placeholder={translations[language].websiteLink}
            />
          </div>

          <div className="event-media-input mb-3">
            <label className="upload-file" for="img-input">{translations[language].uploadImage}</label>
            <input
              type="file"
              id = "img-input"
              onChange={(e) => setImageFile(e.target.files[0] || null)}
              accept="image/*"
            />
          </div>

          <div>
            <button type="submit" className = "btn btn-primary form-action-button">{translations[language].createLocation}</button>
            <button type="button" onClick={onClose} className="btn btn-danger form-action-button ms-2" >{translations[language].cancel}</button>
          </div>
        </form>


    </div>
  )

}
export default LocationForm